import config from '@plone/volto/registry';

/**
 * Strip the API URL out of stored rich text, without building a regular
 * expression out of it.
 *
 * Volto's own `flattenHTMLToAppURL` does
 * `html.replace(new RegExp(settings.apiPath, 'g'), '')`, and the path goes in
 * unescaped. That is fine as long as it contains no regex metacharacters -
 * which is why this site never saw it - but an apiPath ending in `/++api++`,
 * as hrl-site's does, compiles to a quantifier with nothing to repeat:
 *
 *   Invalid regular expression: /https://…/++api++/g: Nothing to repeat
 *
 * The whole page then fails to render. It surfaced on the topic pages there
 * because `topic_description` had only just started being displayed, but
 * every rich text field on every view runs through the same helper.
 *
 * split/join needs no pattern at all and replaces every occurrence, which is
 * what the `g` flag was for.
 */
const stripAll = (text, needle) =>
  needle ? text.split(needle).join('') : text;

export function flattenRichTextToAppURL(html) {
  const { settings } = config;
  return stripAll(
    stripAll(html || '', settings.internalApiPath),
    settings.apiPath,
  );
}

export default flattenRichTextToAppURL;
